/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import { VueHeadMixin, createHead } from '@unhead/vue'
import VueCookies from 'vue-cookies'

import { initSentry } from '@/plugins/sentry'
import router from '@/router'
import store from '@/store'

import i18n from './i18n'
import createVuetify from './vuetify'
import './axios'

// Types
import type { App } from 'vue'

export async function registerPlugins (app: App) {
  initSentry(app, router)
  const head = createHead()

  const vuetify = await createVuetify()

  app
    .use(store)
    .use(i18n)
    .use(vuetify)
    .use(router)
    .use(VueCookies)
    .use(head)
    .mixin(VueHeadMixin)
}
